import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    center: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    header: {
      padding: 20,
      borderBottomWidth: 1,
    },
    title: {
      fontSize: 28,
      fontWeight: 'bold',
      marginBottom: 15,
    },

    // Search
    searchRow: {
      flexDirection: 'row',
      gap: 10,
      marginBottom: 12,
    },
    searchContainer: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      borderWidth: 1,
      borderRadius: 10,
      paddingHorizontal: 12,
    },
    searchInput: {
      flex: 1,
      paddingVertical: 12,
      fontSize: 16,
    },

    // Filter Icon Button
    filterIconBtn: {
      width: 48,
      height: 48,
      borderRadius: 10,
      borderWidth: 1,
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    },
    filterBadge: {
      position: 'absolute',
      top: -6,
      right: -6,
      width: 20,
      height: 20,
      borderRadius: 10,
      justifyContent: 'center',
      alignItems: 'center',
    },
    filterBadgeText: {
      color: '#fff',
      fontSize: 11,
      fontWeight: 'bold',
    },

    clearAllFiltersBtn: {
      paddingVertical: 8,
      paddingHorizontal: 12,
      borderRadius: 8,
      borderWidth: 1,
      alignItems: 'center',
      marginBottom: 12,
    },
    clearAllFiltersBtnText: {
      fontSize: 13,
      fontWeight: '500',
    },

    createBtn: {
      padding: 15,
      borderRadius: 10,
      alignItems: 'center',
    },
    createBtnText: {
      fontSize: 16,
      fontWeight: 'bold',
    },

    emptyList: {
      flexGrow: 1,
    },

    // Menu Modal
    modalOverlay: {
      flex: 1,
      justifyContent: 'flex-end',
    },
    menuModal: {
      borderRadius: 12,
      minWidth: 200,
      overflow: 'hidden',
    },
    menuItem: {
      padding: 16,
    },
    menuItemContent: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    menuItemText: {
      fontSize: 16,
    },
    menuDivider: {
      height: 1,
    },
  });
